import appModel from "./App";
const storeModel = {
    app: appModel,
};
export default storeModel;